import { render, staticRenderFns } from "./MovePredictionWithActualToSaving.vue?vue&type=template&id=01f707b4&scoped=true"
import script from "./MovePredictionWithActualToSaving.vue?vue&type=script&lang=js"
export * from "./MovePredictionWithActualToSaving.vue?vue&type=script&lang=js"
import style0 from "./MovePredictionWithActualToSaving.vue?vue&type=style&index=0&id=01f707b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f707b4",
  null
  
)

export default component.exports